import { Breadcrumb } from '@sentry/browser';
import * as Sentry from '@sentry/electron';

import { isSentryReportingEnabled } from '~/root/tools/utils/Sentry';

const { addBreadcrumb: _addBreadcrumb, Severity } = Sentry;

export const addBreadcrumb = (isSentryReportingEnabled ? _addBreadcrumb : () => {}) as (
  breadcrumb: Breadcrumb,
) => void;
export { Severity };
